import { adaptiveWrapperOptions } from '@psl/appComponents/ModalWrapper';
import { screenOptionsForLightMode } from '@psl/functions/navigation/screenOptions';
import { wrapLazyNavigatorScreen } from '@psl/functions/navigation/utils/wrapNavigatorScreen';
import { lazy } from 'react';

const YouTubeVideoPageContent = lazy(() => import('./YouTubeVideoPageContent'));

export const YouTubeVideoPage = wrapLazyNavigatorScreen(
  YouTubeVideoPageContent,
  () =>
    adaptiveWrapperOptions(isMobile =>
      isMobile
        ? screenOptionsForLightMode({
            presentation: 'modal',
          })
        : screenOptionsForLightMode({
            presentation: 'transparentModal',
            cardOverlayEnabled: true,
            cardStyle: { backgroundColor: 'transparent' },
            animationEnabled: false,
            headerShown: false,
          }),
    ),
);
